import { render, staticRenderFns } from "./ExpectedRevenue.vue?vue&type=template&id=10197230&"
import script from "./ExpectedRevenue.vue?vue&type=script&lang=js&"
export * from "./ExpectedRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports